import React from "react";
import PropTypes from "prop-types";

import "./ColorButton.scss";

export default class ColorButton extends React.Component {
  render() {
    const { text, onClick, loading } = this.props;

    return (
      <div className="submitCodeDiv">
        <button onClick={onClick} style={{ backgroundColor: this.props.color }}>
          {loading ? "Loading..." : text}
        </button>
      </div>
    );
  }
}

ColorButton.propTypes = {
  text: PropTypes.string,
  onClick: PropTypes.func,
  color: PropTypes.string,
  loading: PropTypes.bool
};
